<ng-container *ngIf="vm$ | async as vm">
  <div class="banner-section">
    <rd-rcv2-checkout-banner-wrapper
      [redeemCashLoyaltyProgram]="vm.redeemCashLoyaltyProgram">
    </rd-rcv2-checkout-banner-wrapper>
  </div>

  <div class="container grid gap-8 md:grid-cols-2">
    <div class="rc-side-container flex-shrink-0">
      <rd-rcv2-checkout-terms-list
        class="w-full"
        [loyaltyCurrencySelected]="vm.loyaltyCurrencySelected"
        [redeemCashLoyaltyProgram]="vm.redeemCashLoyaltyProgram">
      </rd-rcv2-checkout-terms-list>
    </div>
    <div class="rc-details-container flex-grow">
      <div class="rc-detail-item-wrapper">
        <rd-rcv2-checkout-information
          [loyaltyCurrencySelected]="vm.loyaltyCurrencySelected"
          [loading]="vm.redeemCashLoyaltyProgramOrMembershipsAreLoading">
        </rd-rcv2-checkout-information>
      </div>
      <div
        class="rc-detail-item-wrapper"
        [ngClass]="{
          'mt-5': !vm.redeemCashLoyaltyProgramOrMembershipsAreLoading
        }">
        <rd-rcv2-checkout-form-wrapper
          #conversionForm
          [formData]="vm.checkoutFormData"
          [redeemCashLoyaltyProgram]="vm.redeemCashLoyaltyProgram"
          (submitForm)="
            submitCheckoutFormData(
              $event,
              vm.redeemCashLoyaltyProgram,
              vm.loyaltyCurrencySelected
            )
          "
          [disabled]="!vm.isFormEnable"
          [loading]="vm.redeemCashLoyaltyProgramOrMembershipsAreLoading"
          [redeemCashMembership]="vm.redeemCashMembership"
          [isLoggedIn]="vm.isLoggedIn"></rd-rcv2-checkout-form-wrapper>
      </div>
    </div>
  </div>
</ng-container>
